import { Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import TopReviewDriver from "./TopReviewDriver";
import OtherReviewDriver from "./OtherReviewDriver";
import { $crud } from "../../../utils/CrudFactory";

const DriverReviews = ({
  showAllReviews,
  onViewAllClick,
  dateFilter,
  setDateFilter,
}) => {
  const [reviews, setReviews] = useState([]);

  async function retrieveData() {
    const { data } = await $crud.retrieve("admin/driver-reviews", {
      from: dateFilter.from,
      to: dateFilter.to,
    });
    setReviews(data.data);
  }

  useEffect(() => {
    retrieveData();
  }, [dateFilter.from, dateFilter.to, showAllReviews]);

  return (
    <>
      <Grid container sx={{ padding: "0 18px" }}>
        {!showAllReviews && (
          <Grid item xs={12} mt={"10px"}>
            <TopReviewDriver />
          </Grid>
        )}
        <Grid item xs={12} sx={{ marginTop: "28px" }}>
          <OtherReviewDriver
            showAllReviews={showAllReviews}
            onViewAllClick={onViewAllClick}
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
            reviews={reviews}
            setReviews={setReviews}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DriverReviews;
